import {takeEvery, put, call} from "redux-saga/effects"

import {LOGIN_USER, LOGOUT_USER} from "./actionTypes"
import {loginSuccess, loginError, logoutSuccess, logoutError} from "./actions"

import {
  apiPostJwtLogin,
} from "../../../api/calls/login"

import {refreshToken} from "../../../api/api";
import {havePermission} from "../../../common/general";

function* loginUser({payload: data}) {
  try {
    const response = yield call(apiPostJwtLogin, data)
    localStorage.setItem("authUser", JSON.stringify(response.response))
    refreshToken()
    yield put(loginSuccess(response))
    if (havePermission(1)) {
      data.history.push("/dashboard")
    } else if (havePermission(2)) {
      data.history.push("/dashboard")
    } else if (havePermission(3)) {
      if (havePermission(21)) {
        data.history.push("/files")
      } else if (havePermission(20)) {
        data.history.push("/inbox")
      } else if (havePermission(22)) {
        data.history.push("/search")
      } else {
        data.history.push("/logout")
      }
    } else if (havePermission(4)) {
      data.history.push("/simple-inbox")
    } else {
      data.history.push("/logout")
    }

  } catch (error) {
    yield put(loginError(error))
  }
}

function* logoutUser({payload: data}) {
  try {
    localStorage.removeItem("authUser")
    yield put(logoutSuccess())
    data.history.push("/login")
  } catch (error) {
    yield put(logoutError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
